import {ClickEvent} from "../../../infrastructure/models/analytics/click-event";
import {ANALYTICS} from "../../../third-party-services/analytics/analytics-consts";

export class PropositionBetsWidgetMarketClickEvent extends ClickEvent {
  gameId: Number;
  status: Number;
  source: String;
  sportTypeId: Number;
  marketType: String;
  clickType: String;

  constructor(params) {
    super('', 'market_click', 'props');

    this.gameId = params.gameId;
    this.status = params.status;
    this.source = params.source;
    this.sportTypeId = params.sportTypeId;
    this.marketType = params.marketType;
    this.clickType = params.clickType;
  }

  get properties() {
    const properties = super.properties;

    properties.gameId = this.gameId;
    properties.status = ANALYTICS.GAME_STATUSES[this.status];
    properties.source = this.source;
    properties.sportTypeId = this.sportTypeId;
    properties.marketType = this.marketType;
    properties.clickType = this.clickType;

    return properties;
  }
}